/**
 * HPH Quick Add to Cart
 * AJAX add to cart that integrates with Horizon's cart drawer.
 * Posts to /cart/add.js with section IDs, dispatches cart:update
 * so Horizon refreshes badge + drawer via Section Rendering API.
 *
 * NEVER modify textContent of the button (destroys inner <span> structure
 * needed for CSS grid animation). Use CSS classes only for state feedback.
 *
 * Created: June 8, 2026. Rewritten: June 9, 2026.
 */
(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-hph-quick-add]');
    if (!btn || btn.hasAttribute('disabled')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-hph-quick-add');

    /* Disable + loading state (CSS only, no text change) */
    btn.setAttribute('disabled', 'true');
    btn.classList.add('hph-quick-add--loading');

    /* Get section ID for Section Rendering API */
    var sectionId = '';
    var drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent) {
      var sectionEl = drawerComponent.closest('[id^="shopify-section-"]');
      sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
    }

    var addBody = {
      id: parseInt(variantId, 10),
      quantity: 1
    };
    if (sectionId) {
      addBody.sections = sectionId;
      addBody.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(addBody)
    })
    .then(function(res) {
      if (res.status === 422) {
        return res.json().then(function(err) {
          throw new Error(err.description || 'Could not add to cart');
        });
      }
      if (!res.ok) throw new Error('Network error');
      return res.json();
    })
    .then(function(responseData) {
      /* Dispatch immediately from the add response - no second /cart.js round-trip.
         Why this is safe:
          - hph-cart-fill.js listens for this cart:update (source product-form-component), re-renders
            the drawer section via Horizon's hydrating renderer, then opens the drawer.
          - The header badge is a <cart-icon> that self-updates on this same event.
         The old blocking GET /cart.js was a pure extra round-trip before the cart showed. */
      var eventDetail = {
        sourceId: 'hph-quick-add',
        data: {
          source: 'product-form-component',
          itemCount: 1,
          variantId: variantId
        }
      };
      if (responseData.sections) {
        eventDetail.data.sections = responseData.sections;
      }
      /* Best-effort a11y count without a fetch (present on add.js responses that include it). */
      if (typeof responseData.item_count === 'number') {
        eventDetail.resource = { item_count: responseData.item_count };
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: eventDetail
      }));

      /* Success state: color change only, no text modification */
      btn.classList.remove('hph-quick-add--loading');
      btn.classList.add('hph-quick-add--success');
      setTimeout(function() {
        btn.removeAttribute('disabled');
        btn.classList.remove('hph-quick-add--success');
      }, 1200);
    })
    .catch(function() {
      btn.classList.remove('hph-quick-add--loading');
      btn.removeAttribute('disabled');
    });
  });
})();
